<div class="login">
  <div class="card offset-0 offset-md-2 px-5 py-5">
    <img *ngIf="logo" class="mb-5 logo-edunet" [src]="logo" alt="logo">
    <div class="social-sign-in">
      <button (click)="signInWithFb()" class="w-100" nz-button nzType="default" nzSize="large" nzShape="round">
        <img class="social-login__icon social-login__icon--fb" src="assets/icons/icons8-facebook-48.png" alt="facebook">
        <span>{{ 'login.withFb' | transloco }}</span>
      </button>
      <button (click)="signInWithGg()" class="w-100 mt-4" nz-button nzType="default" nzSize="large" nzShape="round">
        <img class="social-login__icon social-login__icon--gg" src="assets/icons/icons8-google-48.png" alt="google">
        <span>{{ 'login.withGg' | transloco }}</span>
      </button>
    </div>
    <nz-divider [nzText]="text">
      <ng-template #text>
        <span class="divider-text">{{ 'login.orLabel' | transloco }}</span>
      </ng-template>
    </nz-divider>
    <form nz-form [formGroup]="loginForm" class="login-form" (ngSubmit)="login()">
      <nz-form-item>
        <nz-form-control nzErrorTip="{{ 'login.requiredEmail' | transloco }}">
          <nz-input-group [nzPrefixIcon]="isInputPhoneNumber ?  'phone' : 'mail'">
            <input appRemoveWhitespaceCharsOnPaste type="text" nz-input formControlName="email" placeholder="{{ 'login.phoneOrEmail' | transloco }}"
                   (ngModelChange)="onChangeEmailOrPhone($event)"/>
          </nz-input-group>

        </nz-form-control>
      </nz-form-item>
      <nz-form-item class="mt-2">
        <nz-form-control nzErrorTip="{{ 'login.requiredPw' | transloco }}">
          <nz-input-group nzPrefixIcon="lock">
            <input appRemoveWhitespaceCharsOnPaste type="password" nz-input formControlName="password" placeholder="{{ 'login.pwPlaceholder' | transloco }}" autocomplete="off" />
          </nz-input-group>
        </nz-form-control>
      </nz-form-item>
      <div nz-row class="login-form-margin">
        <div nz-col [nzSpan]="12">
        </div>
      </div>
      <button
        [disabled]="loginForm.invalid"
        nz-button
        class="login-form-button login-form-margin d-flex justify-content-center"
        [nzLoading]="loading" [nzType]="'primary'"
      >
        {{ 'login.loginBtn' | transloco }}
      </button>
      <div><a [routerLink]="'/forgotpw'">{{ 'login.forgotPwBtn' | transloco }}</a></div>
      <div>{{ 'login.noAcc' | transloco }} <a [routerLink]="'/signup'">{{ 'login.registerNow' | transloco }}</a></div>
    </form>
    <div class="d-flex justify-content-between align-items-center mt-4" style="font-size: 14px;">
      <label class="me-3">{{ 'language.chooseLang' | transloco }}</label>
      <app-lang-select></app-lang-select>
    </div>
    <div class="mt-5 hadtech-logo-container"><img class="hadtech-logo" src="assets/images/logo.svg" alt="logo"></div>
  </div>
</div>
<img class="mascot mascot__login" src="https://cdn.khanhhoanoitienganh.org/edunet/public/2023/sutu/SuTu-Gif-vay1tay.gif" alt="mascot">

<ng-template #loginErrorTpl>
  <nz-alert
    nzType="error"
    [nzDescription]="loginErrorMsgTpl"
    nzShowIcon
  >
    <ng-template #loginErrorMsgTpl>
      <div>{{(isInputPhoneNumber ? 'login.loginErrPhone' : 'login.loginErr') | transloco}}</div>
      <div>{{ 'login.tryAgain' | transloco }}</div>
    </ng-template>
  </nz-alert>
</ng-template>
<ng-template #socialLoginErrorTpl>
  <nz-alert
    nzType="error"
    [nzDescription]="socialLoginErrorMsgTpl"
    nzShowIcon
  >
    <ng-template #socialLoginErrorMsgTpl>
      <div style="padding-right: 18px;">{{ socialLoginError }}</div>
    </ng-template>
  </nz-alert>
</ng-template>
